import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'environments/environment';

/** Applies the installation's brand to the browser tab: title and, when declared, favicon. */
export function applyBrand(): void {
  const brand = environment.appearance?.brand;
  if (!brand) return;

  inject(Title).setTitle(brand.name);

  if (brand.favicon) {
    inject(DOCUMENT)
      .querySelector<HTMLLinkElement>('link[rel="icon"]')
      ?.setAttribute('href', brand.favicon);
  }
}
